<script setup lang="ts">
import "highlight.js/lib/common";
import hljsVuePlugin from "@highlightjs/vue-plugin";

const highlightjs = hljsVuePlugin.component;

defineProps<{
    code: string;
    autodetect?: boolean;
}>();
</script>
<template>
    <div>
        <highlightjs
            :autodetect="autodetect || true"
            language="html"
            :code="code"
        />
    </div>
</template>
